import { render } from "./MerchPage.vue?vue&type=template&id=5fa229d8&scoped=true"
import script from "./MerchPage.vue?vue&type=script&lang=js"
export * from "./MerchPage.vue?vue&type=script&lang=js"

import "./MerchPage.vue?vue&type=style&index=0&id=5fa229d8&scoped=true&lang=css"
import "./MerchPage.vue?vue&type=style&index=1&id=5fa229d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa229d8"]])

export default __exports__